import styled from "styled-components";

export const StyledInput = styled.input`
  padding: 5px;
  color: white;
  background-color: rgba(255, 255, 255, 0.2);
  outline: none;
  border: none;
`;

export const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 5px;
  color: white;
  outline: none;
  border: none;
  background-color: rgba(255, 255, 255, 0.2);
`;
